<script>
  export default {
    name: 'KeepAliveRouteView',
    props: {
      keepAlive: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        cachePageList: [], //页面缓存池
      }
    },
    watch: {
      '$route.path': {
        immediate: true,
        handler() {
          //meta上有keepAlive，则缓存页面
          if (this.$route.meta.keepAlive) this.addCache(this.$route.name)
        },
      },
    },
    created() {},
    updated() {
      console.log('')
    },
    methods: {
      /**
       * 添加页面缓存
       * @param name
       */
      addCache(name) {
        if (!this.cachePageList.includes(name)) {
          this.cachePageList.push(name)
        }
      },
    },
  }
</script>

<template>
  <keep-alive :include="cachePageList">
    <router-view></router-view>
  </keep-alive>
</template>

<style lang="scss" scoped></style>
